export default{
    root: {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
    },
};